import SearchButton from "./SearchButton";
import FilterButton from "./FilterButton";

export const Components = {
    icons: {
        SearchIcon : SearchButton,
        ViewColumnIcon : FilterButton,
    }
}